module.exports = __webpack_public_path__ + "static/media/logoguanabara.711db6cb.png";